import * as React from 'react'
import cc from 'classcat'
import CaretUp from '../Icons/CaretUp'
import CaretDown from '../Icons/CaretDown'

import s from './styles.module.css'

export default class Expandable extends React.Component {
  state = { open: false }

  toggle = () => {
    this.setState(state => ({ open: !state.open }))
  }

  close = () => {
    this.setState({ open: false })
  }

  render() {
    const {
      label,
      children,
      className,
      labelClassName,
      caretClassName,
      render
    } = this.props

    return (
      <div className={cc([s.wrapper, className])}>
        <button className={cc([s.label, labelClassName])} onClick={this.toggle}>
          {label}{' '}
          {this.state.open ? (
            <CaretUp className={cc([s.icon, caretClassName])} />
          ) : (
            <CaretDown className={cc([s.icon, caretClassName])} />
          )}
        </button>
        <div
          className={cc([
            s.content,
            {
              [s.open]: this.state.open
            }
          ])}
        >
          {this.state.open
            ? render({
                expanded: this.state.open,
                collapse: this.close
              })
            : null}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Expandable/index.js